<template>
  <div>
    <Row class="provision-content" :style="{height:`${clientHeight}px`,overflow:'auto',margin:'-16px',}">
      <p class="indent-p">尊敬的用户您好，在同意本协议前，请您认真阅读并充分知悉、理解平台的各项规则及要求，以及国家关于互联网信息服务的法律法规等。如果您对本协议的任何条款表示异议，您可以选择不使用；使用则视为您同意遵守本协议项下约定的全部内容，以及我们后续对协议随时所做的任何修改，并完全接受我们的统一管理。本协议已对与您的权益有或可能具有重大关系的条款，及对平台具有或可能具有免责或限制责任的条款用粗体字予以标注，请您注意。</p>
      <p>一、协议适用主体范围</p>
      <p>1、本协议为安盾网《案件交易》的补充协议，是其不可分割的组成部分，与其构成统一整体。</p>
      <p>2、本协议适用于安盾网律师用户，是您与安盾网之间关于您使用安盾网案件购买服务所订立的协议。</p>
      <p>二、权利声明</p>
      <p class="bold-text">1、您可随时在安盾网查看您的案件购买情况。如有对所购买案件存在异议，您可以向安盾网平台提出，经平台核对后确有错误的，将予以更正。</p>
      <p>2、安盾网平台系统因下列状况无法正常运作，使您无法使用案件购买或导致财产丢失时，安盾网不承担损害赔偿责任，该状况包括但不限于：</p>
      <p>（1）在安盾网平台公告之系统停机维护、升级、调整期间；</p>
      <p>（2）电信通讯或设备出现故障不能进行数据传输的；</p>
      <p>（3）因台风、地震、海啸、洪水、停电、战争、恐怖袭击、政府管制等不可抗力之因素，造成安盾网平台系统障碍不能执行业务的；</p>
      <p>（4）由于黑客攻击、电信部门技术调整或故障、网站升级、相关第三方的问题等原因而造成的服务中断或者延迟。</p>
      <p>三、具体条约</p>
      <p class="bold-text">1、安盾所出售案件，售价可能会根据案件实际情况发生波动，请以实际付款为准；</p>
      <p class="bold-text">2、如选用案件购买功能，用户需根据所选购案件，先期支付所选案件总价的10%作为前期预约金；</p>
      <p class="bold-text">3、预约成功可支付尾款的案件，用户需三个工作日内支付剩余款项，逾期未支付，安盾网有权收回案件，预约金不予退返；</p>
      <p class="bold-text">4、案件预约成功后，在预约期间案件如有问题，可向安盾提出退回，如退回原因是案件自身原因，安盾确认后，退回案件定金；如退回原因是律师自身原因，安盾确认后，案件定金不予退回；</p>
      <p class="bold-text res-text">5、案件付尾款后，律师需在7个工作日内复核证据（包括证据效力、当事人状况、主体关联性等），在此期间案件如有问题，可向安盾提出退回，如退回原因是案件自身原因，律师需在付尾款后7个工作日内提出退回，经安盾确认后，退回案件全部款项；如退回原因是律师自身原因，安盾确认后，案件款项不予退回；</p>
      <p class="bold-text res-text">6、【交易中心不予退案情形】1.案件侵权人为公司主体，该公司在案件取证之后注销；2.案件侵权人为个体工商户，该工商户注销（此种情况，律师可以直接起诉经营者，无需退案，需律师自行查档）；3.涉及专利案件，该专利在案件购买之后被无效的，交易中心不予退案，是否项目补偿由项目经理决定。</p>
      <p class="bold-text">7、平台管理费计算规则：逾期付款的案件，逾期首日将收取案件售价的3%的平台管理费，之后每逾期一天，将收取案件售价的0.3%的平台管理费。</p>
      <p>四、附则</p>
      <p>1、平台保留修改或增补本协议内容的权利。本协议的修改文本将公告于平台或以其他平台认为可行的方式公告。修改文本一旦公布则立即生效，且对生效前的用户同样适用。若您在本协议内容发生修订后，继续使用本服务的，则视为您同意最新修订的协议内容；否则您须立即停止使用本服务。</p>
      <p>2、因本协议引起的或与本协议有关的争议，均适用中华人民共和国法律。</p>
      <p>3、因本协议引起的或与本协议有关的争议，安盾网平台与您将协商解决。协商不成的，任何一方均有权向本协议签订地有管辖权的法院提起诉讼。</p>
      <p>4、本协议部分内容被有管辖权的法院认定为违法或无效的，不因此影响其他内容的效力。</p>
      <p class="bold-text">5、本协议的最终解释权归安盾网所有。</p>
      <p>6、本协议签订地：深圳市南山区</p>
      <Row style="text-align: center;">
        <Button type="primary" @click="openProvision">我已阅读并同意《购买条款》</Button>
      </Row>

    </Row>
  </div>
</template>
<script>
export default {
  components: {},
  props: [''],
  data () {
    return {
      clientHeight: ''
    }
  },
  watch: {},
  created() {},
  beforeMount() {
    this.clientHeight = (document.body.clientHeight - 55) * 0.7
  },
  mounted() {},
  updated() {},
  methods: {
    openProvision() {
      this.$emit('changeModal', true)
    }
  }
}
</script>
<style lang="scss" scoped>
.spec-p{
    text-indent: 18px;
}
.provision-content{
    font-size: 14px;
    padding:16px;
    line-height: 24px;
    .indent-p{
        text-indent: 20px;
        margin-bottom: 5px;
    }
    .bold-text{
        font-weight: 600;
    }
    .res-text{
        color:red;
    }
}
</style>



// WEBPACK FOOTER //
// src/view/tradingCenter/orderManage/payText.vue